import { z } from "zod";
//#region src/work-name.ts
/** Max length of a work-unit name, in characters. See the header for why 40 and not 63. */
const WORK_NAME_MAX_LENGTH = 40;
/**
* The one work-unit name grammar: lower-case alphanumerics and hyphen, beginning AND ending
* alphanumeric, length capped at {@link WORK_NAME_MAX_LENGTH} **by construction** (1 + 38 + 1).
*
* Linear — a bounded quantifier over a character class, so it is ReDoS-free on any input.
*/
const WORK_NAME_PATTERN = /^[a-z0-9]([a-z0-9-]{0,38}[a-z0-9])?$/;
/** Zod schema for {@link WORK_NAME_PATTERN}. The `.max()` is redundant against the pattern's own
*  cap and is kept because it is the shipped composition of `workPoolNameSchema`, and because it
*  produces a length-specific error message instead of a bare regex mismatch. */
const workNameSchema = z.string().min(1).max(40).regex(WORK_NAME_PATTERN, { message: `must be a work-unit name: lower-case letters, digits and hyphens, beginning AND ending with a letter or digit, at most 40 characters` });
/**
* True iff `v` is a string satisfying {@link WORK_NAME_PATTERN}.
*
* ⛔ THE ONLY SANCTIONED PREDICATE. The publish-door rules and every runtime door call this, so a
* door cannot hand-roll a looser test. ⛔ Do NOT add a separate `v.length <= WORK_NAME_MAX_LENGTH`
* conjunct: the pattern already caps at 40, so the extra clause is unreachable-in-effect and
* `W-N4` proves the equivalence at the boundary instead.
*/
function isValidWorkName(v) {
	return typeof v === "string" && WORK_NAME_PATTERN.test(v);
}
//#endregion
export { WORK_NAME_MAX_LENGTH, WORK_NAME_PATTERN, isValidWorkName, workNameSchema };

//# sourceMappingURL=work-name.js.map